// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__cWs10","label":"LanguagePicker_label__5PZ2V","icon":"LanguagePicker_icon__r7ejD"};